import { CREDIT_PACKS, type CreditPack } from '../config/creditPacks';

export const PACK_TIER_ORDER = ['pack-monthly', 'pack-quarterly', 'pack-halfyearly'] as const;

export type PackTierId = (typeof PACK_TIER_ORDER)[number];

export function getPackTierIndex(packId: string | null | undefined): number {
  if (!packId) return -1;
  return PACK_TIER_ORDER.indexOf(packId as PackTierId);
}

export function isPaidPackId(packId: string | null | undefined): boolean {
  return getPackTierIndex(packId) >= 0;
}

export function isHigherTierPack(targetPackId: string, currentPackId: string | null): boolean {
  const targetIdx = getPackTierIndex(targetPackId);
  const currentIdx = getPackTierIndex(currentPackId);
  if (targetIdx < 0) return false;
  if (currentIdx < 0) return true;
  return targetIdx > currentIdx;
}

export function isSamePack(targetPackId: string, currentPackId: string | null): boolean {
  return Boolean(currentPackId && targetPackId === currentPackId);
}

export function getNextHigherPack(currentPackId: string | null): PackTierId | null {
  const idx = getPackTierIndex(currentPackId);
  if (idx < 0) return PACK_TIER_ORDER[0];
  if (idx >= PACK_TIER_ORDER.length - 1) return null;
  return PACK_TIER_ORDER[idx + 1];
}

export function getSelectableCheckoutPacks(): CreditPack[] {
  return CREDIT_PACKS;
}

export function formatPlanRenewalDate(periodEnd: string | null): string | null {
  if (!periodEnd) return null;
  const end = new Date(periodEnd);
  if (Number.isNaN(end.getTime())) return null;
  return end.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatPlanTimeline(
  periodEnd: string | null,
  daysLeft: number | null,
  isExpired: boolean,
): string | null {
  const formatted = formatPlanRenewalDate(periodEnd);
  if (!formatted) return null;
  if (isExpired) return `Expired ${formatted}`;
  if (daysLeft != null && daysLeft <= 0) return `Ended ${formatted}`;
  if (daysLeft != null && daysLeft <= 7) {
    return `Renews in ${daysLeft} day${daysLeft === 1 ? '' : 's'} · ${formatted}`;
  }
  return `Renews ${formatted}`;
}
